var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0833 12.6666H12.6666C12.1804 12.6666 11.714 12.8598 11.3702 13.2036C11.0264 13.5474 10.8333 14.0137 10.8333 14.5V27.3333C10.8333 27.8195 11.0264 28.2858 11.3702 28.6297C11.714 28.9735 12.1804 29.1666 12.6666 29.1666H25.4999C25.9861 29.1666 26.4525 28.9735 26.7963 28.6297C27.1401 28.2858 27.3333 27.8195 27.3333 27.3333V20.9166",
    stroke: "currentColor",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9583 11.2917C26.3229 10.927 26.8175 10.7222 27.3333 10.7222C27.849 10.7222 28.3436 10.927 28.7083 11.2917C29.0729 11.6564 29.2778 12.151 29.2778 12.6667C29.2778 13.1824 29.0729 13.677 28.7083 14.0417L19.9999 22.75L16.3333 23.6667L17.2499 20L25.9583 11.2917Z",
    stroke: "currentColor",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilder);
export default __webpack_public_path__ + "static/media/builder.f63e99278cd84e2bbfa5e1995a3625d6.svg";
export { ForwardRef as ReactComponent };